import { useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import useScrollLock from '@/hooks/useScrollLock';
import { SidebarContext } from './SidebarContext';

interface SidebarProviderProps {
  children: ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const setIsLocked = useScrollLock();

  // Close sidebar when route changes
  useEffect(() => {
    setOpen(false);
  }, [location]);

  useEffect(() => {
    if (open) {
      setIsLocked(true);
    } else {
      setIsLocked(false);
    }

    return () => {
      setIsLocked(false);
    };
  }, [open, setIsLocked]);

  return (
    <SidebarContext.Provider value={{ open, setOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};
